export default function CIfElse() {
  return <h2>C If Else</h2>;
}
